// @flow

const serviceBase: string = '/service';
const searchBase: string = '/search';
const translateBase: string = '/web-asset';
const gpsBase: string = '/gps';
const authBase: string = '/auth/api';

const path = {
  serviceBase,
  searchBase,
  translateBase,
  gpsBase,
  authBase,
};

const apiKey = {
  mixpanel: '6b9ccb1b1af18fa94794f6d0a1dcb83e',
};

const conf = {
  path,
  apiKey,
};

export default conf;
